// src/pages/EnvironmentalResponsibility.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

export default function EnvironmentalResponsibility() {
  return (
    <section className="max-w-6xl mx-auto px-4 py-20">
      {/* ============================
          SEO
      ============================ */}
      <Helmet>
        <title>Environmental Responsibility | Aerzen Air™</title>
        <meta
          name="description"
          content="Aerzen Air™ follows a lifecycle-based approach to environmental responsibility, focusing on durable design, responsible materials, and long-term impact."
        />
        <link
          rel="canonical"
          href="https://www.aerzenair.com/environmental-responsibility"
        />
      </Helmet>

      {/* HEADER */}
      <div className="mb-14">
        <span className="inline-block mb-3 px-3 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
          Environmental Responsibility
        </span>

        <h1 className="text-4xl font-bold mb-4">
          Our Environmental Commitment
        </h1>

        <p className="text-gray-700 max-w-3xl">
          <strong>AERZEN AIR™</strong> approaches environmental responsibility as
          a lifecycle obligation — extending beyond air purification performance
          to design choices, material usage, and long-term impact.
        </p>
      </div>

      {/* HERO IMAGE */}
      <div className="mb-20 rounded-2xl bg-gray-100 p-6 flex items-center justify-center">
        <img
          src="/images/environment/environment-hero.jpg"
          alt="Environmental responsibility at AERZEN AIR™"
          className="w-full max-w-5xl object-contain rounded-xl"
        />
      </div>

      {/* CONTENT GRID */}
      <div className="grid md:grid-cols-2 gap-12">
        {/* LEFT */}
        <div>
          <h2 className="text-xl font-semibold mb-3">
            Design & Materials
          </h2>
          <p className="text-gray-700 mb-8">
            Products are designed with durability, serviceability, and material
            efficiency in mind. This reduces premature disposal, minimizes
            resource consumption, and extends usable product life.
          </p>

          <h2 className="text-xl font-semibold mb-3">
            Filter & Consumable Responsibility
          </h2>
          <p className="text-gray-700">
            Filter usage, replacement cycles, and maintenance expectations are
            communicated transparently. Responsible handling and disposal
            practices are encouraged to reduce environmental impact.
          </p>
        </div>

        {/* RIGHT */}
        <div>
          <h2 className="text-xl font-semibold mb-3">
            Data-First Environmental Thinking
          </h2>
          <p className="text-gray-700 mb-8">
            Air quality indicators, advisory information, and usage guidance are
            presented to support informed decisions rather than emotional or
            alarmist responses.
          </p>

          <p className="text-gray-700">
            Environmental responsibility is treated as an ongoing process —
            subject to review and improvement as data, materials, and practices
            evolve over time.
          </p>
        </div>
      </div>
    </section>
  );
}
